import { isFirefox } from '@src/lib/device'

import type { AudioDeviceType } from './AudioDeviceProps'
import useDeviceAudio from './useDeviceAudio'

const audioDeviceStatus = {
  NO_DEVICES: {
    type: 'NO_DEVICES',
    message: 'You do not have any additional devices available.',
  },
  UNSUPPORTED_OUTPUT: {
    type: 'UNSUPPORTED_OUTPUT',
    message: 'Your browser does not support changing audio output settings.',
  },
  UNSUPPORTED_INPUT: {
    type: 'UNSUPPORTED_INPUT',
    message: 'Your browser does not support changing audio input settings.',
  },
  SUPPORTED: {
    type: 'SUPPORTED',
    message: '',
  },
} as const

type AudioDeviceStatusKey = keyof typeof audioDeviceStatus
type AudioDeviceStatus = (typeof audioDeviceStatus)[AudioDeviceStatusKey]

export default function useAudioDeviceStatus(
  deviceType: AudioDeviceType,
  devices: MediaDeviceInfo[],
): AudioDeviceStatus {
  const deviceAudio = useDeviceAudio()
  // Firefox does not support changing audio input devices
  // https://www.twilio.com/docs/voice/sdks/javascript/twiliodevice/device-audio#deviceaudiosetinputdevicedeviceid
  if (isFirefox() && deviceType === 'microphone') {
    return audioDeviceStatus.UNSUPPORTED_INPUT
  } else if (!deviceAudio.isOutputSelectionSupported) {
    return audioDeviceStatus.UNSUPPORTED_OUTPUT
  } else if (devices.length === 0) {
    return audioDeviceStatus.NO_DEVICES
  }
  return audioDeviceStatus.SUPPORTED
}
